// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cda612ba","935":"2bf3277a"}[chunkId] + ".chunk.js";
};